import { rem } from "../../../framework/theme/util/misc.js";
import { IconError } from "../../icon/variants/IconError.js";
import form_field_error_module_default from "./form-field-error.module.js";
import { Box } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/inputs/form-field-error/FormFieldError.tsx
const FormFieldError = ({ centered = true, errText, "data-testid": testId }) => {
	return /* @__PURE__ */ jsxs(Box, {
		component: "span",
		className: centered ? form_field_error_module_default.centered : form_field_error_module_default.root,
		pr: "xs",
		pl: "xs",
		"data-testid": testId,
		children: [/* @__PURE__ */ jsx(IconError, {
			color: "error",
			height: rem("20px"),
			width: rem("20px")
		}), errText]
	});
};

//#endregion
export { FormFieldError };